export function stickify(wrapper, stickyEl) {
  const isFixed = 'is-fixed'
  const isBottom = 'is-bottom'
  let stickyHeight = stickyEl.offsetHeight
  let wrapperHeight = wrapper.offsetHeight
  let wrapperRect = wrapper.getBoundingClientRect()
  let stickyRect = stickyEl.getBoundingClientRect()
  let scrollTopValue = document.scrollingElement.scrollTop

  window.addEventListener('resize', function () {
    stickyHeight = stickyEl.offsetHeight
    wrapperHeight = wrapper.offsetHeight
  })

  if (scrollTopValue - stickyHeight > wrapperHeight) {
    stickyEl.classList.add(isBottom)
    stickyEl.classList.remove(isFixed)
  } else if (wrapperRect.top < 0) {
    stickyEl.classList.add(isFixed)
    stickyEl.classList.remove(isBottom)
  } else if (stickyRect.top <= wrapperRect.top) {
    stickyEl.classList.remove(isFixed)
    stickyEl.classList.remove(isBottom)
  }
}

document.addEventListener('DOMContentLoaded', function () {

  if (document.querySelector('.js-sticky-parent')) {
    stickify(document.querySelector('.js-sticky-parent'), document.querySelector('.js-sticky-sidebar'))

    window.addEventListener('scroll', function () {
      stickify(document.querySelector('.js-sticky-parent'), document.querySelector('.js-sticky-sidebar'))
    })
  }

})
